/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from 'react';

import { isTokenPresent } from "../utils/auth";
import { DocumentCategory } from "../utils/Interface/DocumentCategory";
import useSpecialToken from '../utils/hooks/useSpecialToken';
import apiRoutes from '../utils/hooks/apiRoutes';

import TabsNav from "../components/TabsNav";
import Menu from "../components/Menu";
import "../style/css/doccategoryconfig.css";
import "../style/css/newmodeldoc.css";
import Header from "../components/Header";
import Button from "../components/Button";
import InputSelect from "../components/InputSelect";
import InputField from "../components/InputField";
import EditorText from '../components/EditorText';

interface NewModelDocProps {}

const NewModelDoc: React.FC<NewModelDocProps> = () => {

  const { userName, specialToken } = useSpecialToken();
  const [newModelName, setNewModelName] = useState<string>('');
  const [newModelTitle, setNewModelTitle] = useState<string>('');
  const [newModelObject, setNewModelObject] = useState<string>('');
  const [newModelContent, setNewModelContent] = useState<string>('Crééz votre modèle ici '); // Initialisez newModelContent avec une chaîne vide
  const [selectCat, setSelectCat] = useState<{ text: string; id: number }[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number>();
  const [editorFocused, setEditorFocused] = useState<boolean>(false);

  //useEffect & fetch data

  useEffect(() => {
    if (!isTokenPresent()) {
      window.location.href = '/';
    }
    fetchData();
  }, []);

  async function fetchData() {

    const headers = {
      'Content-Type': 'application/json',
    };

    try {

      const response = await fetch(apiRoutes.documentsCategoriesGetAll, { headers });

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const jsonData = await response.json();

      const options2 = jsonData.map((item: { id: any; name: any }) => ({
        text: item.name,
        id: item.id,
      }));

      setSelectCat(options2);

      if (options2.length > 0) {
        setSelectedCategoryId(options2[0].id);
      }

    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }

  }


  //functions handleClick & handleSave

  const handleCategoryChange = (selectedCategoryId: number) => {
    setSelectedCategoryId(selectedCategoryId);
  };

  const handleSave = async () => {

    try {

      const requestBody = {
        name: newModelName,
        title: newModelTitle,
        object: newModelObject,
        content: newModelContent,
        glpi_user_id: 2,
        glpi_documents_categories_id: selectedCategoryId,
      };

      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }

      const response = await fetch(apiRoutes.documentsModelsPost, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'special-token': specialToken,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l\'ajout de la catégorie');
      }

      alert('Nouveau modèle de document ajouté avec succès');
      setNewModelName('');
      setNewModelTitle('');
      setNewModelObject('');
      setNewModelContent('');
      window.location.href = '/configuration/documents/modeles';

    } catch (error) {

      console.error('Erreur lors de l\'ajout de la catégorie :', error);

    }

  };

  const handleCancel  = () => {
    window.location.href = '/configuration/documents/modeles';
  };

  const handleEditorFocus = () => {
    setEditorFocused(true);
    setNewModelContent(''); // Vider le contenu initial lors du focus
  };

  return (

    <div className="mainnewmodel">

      <div className="mainnewmodel__box1">

        <Header userName={userName} />

        <div className="mainnewmodel__box1__container">

          <h2 className="mainnewmodel__box1__container__title"> Configuration documents</h2>

          <TabsNav 
          tab1="Catégorie" 
          tab2="Modèle" 
          path1="/configuration/documents/categories" 
          path2="/configuration/documents/modeles" 
          additionalPathsForTab2={['/configuration/documents/modeles/nouveau']} />

          <form className="mainnewmodel__box1__container__form">

            <h5 className="mainnewmodel__box1__container__form__title"> Informations générales</h5>

            <InputField 
            labels={[{ "title": "Nom du modèle" }]} 
            onChange={(newValue) => setNewModelName(newValue[0])} 
            initialValue={[newModelName]} />

            <InputField 
            labels={[{ "title": "Titre du document" }]} 
            onChange={(newValue) => setNewModelTitle(newValue[0])} 
            initialValue={[newModelTitle]} />

            <InputField 
            labels={[{ "title": "Objet du document" }]} 
            onChange={(newValue) => setNewModelObject(newValue[0])} 
            initialValue={[newModelObject]} />

          </form>

          <div>

            <h6> Choisir la catégorie</h6>

            <InputSelect
            selectedKey={11}
            options={selectCat}
            onChange={handleCategoryChange}
            classValue={1}/>

          </div>

          <h6 className="mainnewmodel__box1__container__subtitle"> Corps du document</h6>

          <div className="mainnewmodel__box1__container__editor">

            <EditorText
            initialValue={newModelContent}
            onEditorChange={(content) => setNewModelContent(content)}
            onFocus={handleEditorFocus}
            resetOnFocus={true}/>

          </div>

          <div className="mainnewmodel__box1__container__btn">

            <Button btnName={"Annuler"} onClick={handleCancel} disable={false}/>

            <Button btnName={"Sauvegarder"} onClick={handleSave} disable={false}/>

          </div>

        </div>

      </div>

      <div className="mainnewmodel__menu">

        <Menu />
        
      </div>
    </div>
  );
}

export default NewModelDoc;
